import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useFormik } from 'formik';

import { supplierService } from 'services'
import { routes, strings, handleFilters, getSortIcon, serialNumber, doDateFormat, PaymentStatusBadge, doAmountFormat, capitalize } from 'utils';
import { _Object } from 'utils/interfaces';

import { Button, SearchField, LinkButton, Pagination, Breadcrumbs, SEOHeader, ActiveFilters, TabsHeader, ReactDatePicker } from 'views/components';
import { purchaseService } from 'services/purchase.serveice';
import { RootState } from 'redux/store';
import { useSelector } from 'react-redux';
import { AsyncSelectField, SelectField } from 'views/components/form-inputs';

const InventoyList = () => {
  const { t } = useTranslation()
  const selectAsyncSelect: any = useRef([])

  const [loading, setLoading] = useState(false);
  const [inventories, setInventories] = useState<_Object>([])
  const { me } = useSelector((state: RootState) => state.session)

  const [filterdLabel, setFilteredLabel] = useState<_Object>({})

  const [filterData, setFilterData] = useState<_Object>({
    page: 1,
    per_page: process.env.REACT_APP_PER_PAGE,
    sort: '-created_at',
    start_date: '',
    end_date: '',
    filter: {
      payment_status: '',
      receiving_date: '',
      supplier_id: '',
      invoice_date: '',
    }
  })
  const [filterApply, setFilterApply] = useState(false)
  const [suppliers, setSuppliers] = useState<_Object[]>([])

  useEffect(() => {
    supplierService.getSuppliers('').then((data: _Object) => {
      setSuppliers(data?.items)
    })
  }, [])

  const handleCallApi = () => {
    setLoading(true);
    purchaseService.getPurchases({ ...filterData, q: searchFormik.values.q }).then((data: _Object) => {
      setInventories(data)
      setLoading(false);
    })
  }

  const searchFormik = useFormik({
    initialValues: { q: '' },
    enableReinitialize: true,
    onSubmit: () => {
      if (searchFormik.values.q.trim() !== '') {
        handleCallApi();
      }
    }
  })

  useEffect(() => {
    handleCallApi();
  }, [filterApply, searchFormik.values.q]);

  const deleteItem = (idToDelete: string) => {
    if (window.confirm('Are you sure to delete this item?')) {
      setLoading(true)
      purchaseService.deletePurchase(idToDelete).then(() => {
        purchaseService.getPurchases(filterData).then((data: _Object) => {
          setInventories(data)
          setLoading(false)
        })
      });
    }
  };

  const loadOption = async (inputValue: string, callback: (options: _Object[]) => void) => {
    const res = await supplierService.getSuppliers({ q: inputValue });
    const options = res.items?.map((item: _Object) => { return { label: item?.full_name != '' ? capitalize(item.full_name) : item.mobile_number, value: item.id } });
    callback(options);
  }

  return (
    <>
      <SEOHeader title="Inventory" />
      <Breadcrumbs
        trails={[
          {
            label: t('purchase.purchases'),
            path: ''
          }
        ]}
      />
      <TabsHeader />

      <div className="pos-justify pos-between pos-align pos-center mt-3">
        <div className="d-flex header-loading relative">
          <form onSubmit={searchFormik.handleSubmit}>
            <SearchField
              type="search"
              name="q"
              className="mb-md-0"
              disabled={!searchFormik.values.q}
              value={searchFormik.values.q}
              onChange={(e: _Object) => {
                searchFormik.setFieldValue('q', e.target.value)
              }}
            />
          </form>

          <button className="btn btn-secondary p-2 px-2.5 ms-2" type="button" data-bs-toggle="offcanvas" data-bs-target="#Orderlist" aria-controls="offcanvasRight">
            <svg className="mx-0" xmlns="http://www.w3.org/2000/svg" version="1.1" width="20" height="20" x="0" y="0" viewBox="0 0 512 512"><g><path d="M16 133.612h260.513c7.186 29.034 33.45 50.627 64.673 50.627s57.487-21.593 64.673-50.627H496c8.836 0 16-7.164 16-16s-7.164-16-16-16h-90.142c-7.185-29.034-33.449-50.628-64.673-50.628s-57.488 21.594-64.673 50.628H16c-8.836 0-16 7.164-16 16s7.164 16 16 16zm325.186-50.628c19.094 0 34.628 15.534 34.628 34.627 0 19.094-15.534 34.628-34.628 34.628s-34.628-15.534-34.628-34.628c0-19.093 15.534-34.627 34.628-34.627zM16 272h90.142c7.186 29.034 33.449 50.627 64.673 50.627s57.487-21.593 64.673-50.627H496c8.836 0 16-7.164 16-16s-7.164-16-16-16H235.487c-7.186-29.034-33.449-50.628-64.673-50.628S113.327 210.966 106.141 240H16c-8.836 0-16 7.164-16 16s7.163 16 16 16zm154.814-50.628c19.094 0 34.628 15.534 34.628 34.628 0 19.093-15.534 34.627-34.628 34.627S136.186 275.093 136.186 256c0-19.094 15.534-34.628 34.628-34.628zM496 378.388h-90.142c-7.186-29.034-33.449-50.628-64.673-50.628s-57.487 21.594-64.673 50.628H16c-8.836 0-16 7.164-16 16s7.164 16 16 16h260.513c7.186 29.034 33.449 50.628 64.673 50.628s57.487-21.594 64.673-50.628H496c8.836 0 16-7.164 16-16s-7.163-16-16-16zm-154.814 50.628c-19.094 0-34.628-15.534-34.628-34.628s15.534-34.628 34.628-34.628 34.628 15.534 34.628 34.628-15.534 34.628-34.628 34.628z" fill="#fff" opacity="1" data-original="#fff"></path></g></svg>
          </button>
          <div className="d-flex align-items-center order-button-list ms-3">
            {Object.values(filterData).some(value => !!value) && (
              <ActiveFilters filterdLabel={filterdLabel} setFilteredLabel={setFilteredLabel} setFilterData={setFilterData} filterData={filterData} setFilterApply={setFilterApply} />
            )}
          </div>
        </div>

        <span className="d-flex align-items-center gap-3">
          {/* <Link
            to="#"
            className="primary text-decoration-none"
            data-bs-toggle="modal" data-bs-target="#export-report"
          >
            {t('common.export_report')}
          </Link> */}
          <LinkButton className="btn btn-primary" path={routes.createPurchaseReport} label="Add purchase">
            <i className="fa-solid fa-plus text-white"></i>
          </LinkButton>
        </span>
      </div>

      <div className="card border-0 mt-3">
        <div className="table-responsive" style={{ maxHeight: 'calc(100vh - 242px)' }}>
          <table className="card-body mb-0 table table-borderless table-striped">
            <thead>
              <tr className="bg-white">
                <th>#</th>
                <th>{t('supplier.supplier')}</th>
                <th>{t('common.invoice_no')}</th>
                <th>{t('common.invoice_date')}</th>
                <th>
                  {t('common.receiving_date')}
                </th>
                <th>{t('common.amount')}</th>
                <th>{t('common.paid_amount')}</th>
                <th>{t('orderDetails.payment_status')}</th>
                <th>{t('common.note')}</th>
                <th>
                  <button
                    className="btn p-0 border-0"
                    onClick={() => { handleFilters('sort', filterData.sort === '-created_at' ? 'created_at' : '-created_at', setFilterData) }}>
                    {t('common.createDate')}
                    {getSortIcon(filterData.sort.includes('created_at') ? filterData.sort : '')}
                  </button>
                </th>
                <th className="action">{t('common.action')}</th>
              </tr>
            </thead>

            <tbody>


              {inventories?.items?.map((item: _Object, i: number) => {
                return (
                  <tr className="align-middle" key={i}>

                    <td>{serialNumber(filterData.per_page, inventories?.pagination?.current_page, i)}</td>
                    <td>
                      <span>{item.supplier?.name}</span><br />
                      <small>{item.supplier?.company_name}, {item.supplier.mobile_number}</small>
                    </td>
                    <td>{item.invoice_number}</td>
                    <td>{item?.invoice_date ? doDateFormat(item?.invoice_date) : '-'}</td>
                    <td>{item?.receiving_date ? doDateFormat(item?.receiving_date) : '-'}</td>
                    <td>{doAmountFormat(item.amount ? item.amount : 0)}</td>
                    <td>{doAmountFormat(item.paid_amount ? item.paid_amount : 0)}</td>
                    <td>
                      <PaymentStatusBadge status={item.payment_status} />
                    </td>
                    <td>{item.note}</td>
                    <td>
                      {item?.created_at ? doDateFormat(item?.created_at) : '-'}<br></br>
                    </td>
                    <td>
                      <ul className="list-inline">
                        <li className="list-inline-item">
                          <LinkButton
                            className="link p-0 text-dark"
                            path={`${routes.purchaseReport}/${item?.id}`}
                            label=""
                          >
                            <i className="fa-solid fa-eye"></i>
                          </LinkButton>
                        </li>
                        {me?.role === 'admin' &&
                          <li className="list-inline-item">
                            <Button
                              className="link text-danger p-0"
                              onClick={() => deleteItem(item.id)}>
                              <i className="fa fa-trash text-danger"></i>
                            </Button>
                          </li>
                        }
                      </ul>
                    </td>
                  </tr>
                )
              })}
              {loading === false && inventories?.items?.length === 0 && <tr>
                <td colSpan={13} className="text-center no-entry">
                  <aside>
                    <i className="fa-solid fa-ban"></i>
                    {strings.noRecordFound}
                  </aside>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>

      {inventories?.pagination?.total_pages > 1 &&
        <Pagination
          current_page={inventories?.pagination?.current_page}
          per_page={inventories?.pagination?.per_page}
          total_pages={inventories?.pagination?.total_pages}
          total_items={inventories?.pagination?.total_items}
          onClick={(i: { [key: string]: number }) => {
            setFilterData((prev) => ({
              ...prev,
              page: i.selected + 1,
            }))
            setFilterApply(!filterApply)
          }
          }
        />
      }

      <div className="offcanvas offcanvas-end" id="Orderlist" aria-labelledby="OrderlistLabel">
        <div className="offcanvas-header border-bottom">
          <h5 className="offcanvas-title" id="OrderlistLabel"><strong>Fillter</strong></h5>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>

        <div className="offcanvas-body">

          <div className="col-12">

            <div className="card-body">
              <form>
                <div className="row">
                  <AsyncSelectField
                    isClearable
                    isMulti
                    cacheOptions
                    label={`${t('supplier.suppliers')}`}
                    name="supplier_id"
                    placeholder={t('common.choose_option')}
                    loadOptions={loadOption}
                    ref={(ref: any) => (selectAsyncSelect.current = ref)}
                    defaultOptions={suppliers?.map((item: _Object) => ({
                      label: item?.name != '' ? capitalize(item.name) : item.mobile_number,
                      value: item.id
                    }))}
                    onChange={(val: any) => {
                      const selectedIds = Array.isArray(val) ? val.map((item: any) => item.value) : [];
                      setFilterData((prev: any) => {
                        const updatedFilter = { ...(prev.filter || {}) };

                        if (!selectedIds.length) {
                          delete updatedFilter.supplier_id;
                        } else {
                          updatedFilter.supplier_id = selectedIds;
                        }
                        return {
                          ...prev,
                          filter: updatedFilter,
                        };
                      });
                      setFilteredLabel((prev: any) => {
                        const updated = { ...(prev || {}) };
                        if (!selectedIds.length) {
                          delete updated.supplier_id;
                          return updated;
                        }
                        updated.supplier_id = val.map((x: any) => x.label).join(', ');
                        return updated;
                      });
                    }}
                    value={
                      suppliers
                        ?.map((item: _Object) => ({ label: item?.name != '' ? capitalize(item.name) : item.mobile_number, value: item.id }))
                        .filter((opt: any) =>
                          (filterData.filter?.supplier_id || []).includes(opt.value)
                        ) || []
                    }
                  />

                  <div className="col-6">
                    <ReactDatePicker
                      label={t('common.start_date')}
                      selected={filterData?.start_date ? new Date(filterData.start_date) : null}
                      onChange={(date: Date | null) => {
                        setFilterData((prev: any) => {
                          const updated = { ...prev };
                          if (!date) {
                            delete updated.start_date;
                          } else {
                            updated.start_date = doDateFormat(date, 'YYYY-MM-DD');
                          }
                          return updated;
                        });
                        setFilteredLabel((prev: any) => {
                          const updated = { ...prev };

                          if (!date) {
                            delete updated.start_date;
                            return updated;
                          }
                          updated.start_date = doDateFormat(date);
                          return updated;
                        });
                      }}
                      dateFormat="MMM dd, yyyy"
                      placeholderText="Select start date"
                      className="form-control"
                      isClearable
                    />
                  </div>

                  <div className="col-6">
                    <ReactDatePicker
                      label={t('common.end_date')}
                      selected={filterData?.end_date ? new Date(filterData.end_date) : null}
                      onChange={(date: Date | null) => {
                        setFilterData((prev: any) => {
                          const updated = { ...prev };
                          if (!date) {
                            delete updated.end_date;
                          } else {
                            updated.end_date = doDateFormat(date, 'YYYY-MM-DD');
                          }
                          return updated;
                        });
                        setFilteredLabel((prev: any) => {
                          const updated = { ...prev };
                          if (!date) {
                            delete updated.end_date;
                            return updated;
                          }
                          updated.end_date = doDateFormat(date);
                          return updated;
                        });
                      }}
                      dateFormat="MMM dd, yyyy"
                      placeholderText="Select end date"
                      className="form-control"
                      isClearable
                    />
                  </div>

                  <div className="col-6">
                    <ReactDatePicker
                      label={t('common.invoice_date')}
                      selected={filterData?.filter.invoice_date ? new Date(filterData.filter.invoice_date) : null}
                      onChange={(date: Date | null) => {
                        setFilterData((prev: any) => {
                          const updated = { ...prev };
                          const updatedFilter = { ...(updated.filter || {}) };

                          if (!date) {
                            delete updatedFilter.invoice_date;
                          } else {
                            updatedFilter.invoice_date = doDateFormat(date, 'YYYY-MM-DD');
                          }
                          return {
                            ...updated,
                            filter: updatedFilter,
                          };
                        });
                        setFilteredLabel((prev: any) => {
                          const updated = { ...prev };
                          if (!date) {
                            delete updated.invoice_date;
                            return updated;
                          }
                          updated.invoice_date = doDateFormat(date);
                          return updated;
                        });
                      }}
                      dateFormat="MMM dd, yyyy"
                      placeholderText="Select end date"
                      className="form-control"
                      isClearable
                    />
                  </div>

                  <div className="col-6">
                    <ReactDatePicker
                      label={t('common.receiving_date')}
                      selected={filterData?.filter.receiving_date ? new Date(filterData.filter.receiving_date) : null}
                      onChange={(date: Date | null) => {
                        setFilterData((prev: any) => {
                          const updated = { ...prev };
                          const updatedFilter = { ...(updated.filter || {}) };

                          if (!date) {
                            delete updatedFilter.receiving_date;
                          } else {
                            updatedFilter.receiving_date = doDateFormat(date, 'YYYY-MM-DD');
                          }
                          return {
                            ...updated,
                            filter: updatedFilter,
                          };
                        });
                        setFilteredLabel((prev: any) => {
                          const updated = { ...prev };
                          if (!date) {
                            delete updated.receiving_date;
                            return updated;
                          }
                          updated.receiving_date = doDateFormat(date);
                          return updated;
                        });
                      }}
                      dateFormat="MMM dd, yyyy"
                      placeholderText="Select end date"
                      className="form-control"
                      isClearable
                    />
                  </div>

                  <SelectField
                    name="text"
                    label={t('Sort by')}
                    className="col-12"
                    options={[
                      { value: '-created_at', label: 'Created ↓ (Newest)' },
                      { value: 'created_at', label: 'Created ↑ (Oldest)' }
                    ]}
                    onChange={(e: _Object) => {
                      setFilterData((prev: any) => ({
                        ...prev,
                        sort: e.value,
                      }));
                    }}
                  />
                  <div className="col-12">
                    <Button
                      type="button"
                      onClick={() => setFilterApply(!filterApply)}
                      className="primary mx-auto"
                      data-bs-dismiss="offcanvas" aria-label="Close"
                    >
                      Apply Filters
                    </Button>
                    <Button
                      type="button"
                      onClick={() => {
                        setFilterData({
                          page: 1,
                          per_page: process.env.REACT_APP_PER_PAGE,
                          sort: '-created_at',
                          start_date: '',
                          end_date: '',
                          filter: {
                            supplier_id: '',
                            payment_status: '',
                          }
                        }),
                          setFilteredLabel({})
                        setFilterApply(!filterApply)
                      }}
                      className="secondry text-danger mx-auto"
                      data-bs-dismiss="offcanvas" aria-label="Close"
                    >
                      Clear All
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div >
      </div >
    </>
  )
}
export default InventoyList
